



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import { notifySuccess } from '@/utlitities/notifications';
import {LockAccountEditModel} from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: { StTabs, AccountSettingsInvoice },
})
export default class AdminQueries extends Vue {
  data: any[] = [];
  query: string = 'pipeline';

  @Watch('query')
  async watchQuery() {
    this.data = await stAdminApi.getTableData(this.query);
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.data = await stAdminApi.getTableData(this.query);
  }

  async deleteAccount(guid: string) {
    if (confirm('Willst du das wirklich tun???')) {
      await stAdminApi.removeAccount(guid);
      notifySuccess('Ist zwar eine Success-Meldung, aber irgendwie auch nicht. Der ist weg!');
      await this.loadData();
    } else {
      notifySuccess('Alles abgebrochen, nix passiert...');
    }
  }

  async lockAccount(account: any)
  {
    const model = LockAccountEditModel.fromJS({});
    model.accountGuid = account.Guid;
    model.reason = account.IsLockedAdminReason;
    await stAdminApi.lockAccount(model);
    await this.loadData();
  }

  async unlockAccount(account: any)
  {
    const model = LockAccountEditModel.fromJS({});
    model.accountGuid = account.Guid;
    model.reason = "";
    await stAdminApi.unlockAccount(model);
    await this.loadData();
  }
}
